<template>
  <div class="py-4 lg:py-6 px-3 lg:px-6">
    <h1 v-if="user.id == 1" class="text-green-500 text-3xl font-semibold">Vehicle Policy approvals</h1>
    <h1 v-else class="text-green-500 text-3xl font-semibold">Vehicle Policy</h1>
    <approvals-table></approvals-table>
  </div>
</template>

<script>
import ApprovalsTable from '@/components/Approvals/Vehicle/ApprovalsTable.vue'
import {mapState} from 'vuex'
export default {
  components: { ApprovalsTable },
  computed: {
      ...mapState({
        user: state => state.user
      })
    },
  mounted(){
    
  }
}
</script>

<style>

</style>